import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';

const ThemeContext = createContext();

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within ThemeProvider');
    }
    return context;
};

export const ThemeProvider = ({ children }) => {
    const [isDark, setIsDark] = useState(false);

    // Load theme on mount
    useEffect(() => {
        // Check cookie first
        const savedTheme = Cookies.get('theme');

        // If no cookie, check system preference
        if (!savedTheme) {
            const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            setIsDark(systemPrefersDark);
            Cookies.set('theme', systemPrefersDark ? 'dark' : 'light', { expires: 365 });
        } else {
            setIsDark(savedTheme === 'dark');
        }
    }, []);

    // Apply theme to document
    useEffect(() => {
        if (isDark) {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
    }, [isDark]);

    const toggleTheme = () => {
        const newTheme = !isDark;
        setIsDark(newTheme);
        Cookies.set('theme', newTheme ? 'dark' : 'light', { expires: 365 });
    };

    const value = {
        isDark,
        toggleTheme
    };

    return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};